export class Skill {
    public id: string;
    public title: string;
    public color_index: number;
    public skill_set_id: number;
    public rate: number;
    public description: string;
    public base_rate: number;
}
